// extracted by mini-css-extract-plugin
module.exports = {"circle":"InlineVideoPlayer_circle__pwEro","maxWidth2k":"InlineVideoPlayer_maxWidth2k__VfYCU"};